import Reveal from "./Reveal";
import { IMAGES } from "../../data";

const Caption = () => (
  <div className="absolute inset-x-0 bottom-0 flex items-center justify-between bg-gradient-to-t from-black/85 to-transparent p-5">
    <span className="font-tech text-[10px] uppercase tracking-[0.24em] text-white/85">
      Dokumentasi Proyek
    </span>
    <span className="h-1.5 w-1.5 rotate-45 bg-[#DF9F00]" />
  </div>
);

const Frame = ({ src, alt, className = "", testid }) => (
  <div className={`group relative overflow-hidden rounded-xl ${className}`} data-testid={testid}>
    <img
      src={src}
      alt={alt}
      loading="lazy"
      decoding="async"
      className="h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-105"
    />
    <div className="absolute inset-0 bg-black/10 transition-colors duration-500 group-hover:bg-black/0" />
    <Caption />
  </div>
);

const Gallery = () => (
  <section
    id="proyek"
    data-testid="gallery-section"
    className="bg-[#0F1115] py-20 lg:py-28"
  >
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <p className="font-tech mb-4 flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-white/50">
            <span className="inline-block h-[2px] w-10 bg-[#DF9F00]" />
            Project Documentation
             <span className="inline-block h-[2px] w-10 bg-[#DF9F00]" />
          </p>
          <h2 className="font-display text-3xl font-semibold uppercase tracking-wide text-white sm:text-4xl lg:text-5xl">
            DIPERCAYA UNTUK
            <br />
            MENDUKUNG PROYEK
          </h2>
        </div>
        <p className="max-w-md text-base leading-relaxed text-white/55">
          Dokumentasi penggunaan steger di berbagai pekerjaan konstruksi.
        </p>
      </Reveal>

      <div className="mt-14 hidden gap-5 lg:grid lg:h-[660px] lg:grid-cols-12">
        <Reveal className="lg:col-span-7 lg:h-full">
          <Frame
            src={IMAGES.campus}
            alt="Dokumentasi proyek gedung dengan instalasi steger menyeluruh"
            className="h-full w-full"
            testid="gallery-featured"
          />
        </Reveal>
        <div className="flex flex-col gap-5 lg:col-span-5 lg:h-full">
          <Reveal delay={0.15} className="min-h-0 flex-1">
            <Frame
              src={IMAGES.crane}
              alt="Dokumentasi proyek struktur bangunan dengan steger dan crane"
              className="h-full w-full"
              testid="gallery-item-2"
            />
          </Reveal>
          <Reveal delay={0.25} className="min-h-0 flex-1">
            <Frame
              src={IMAGES.crew}
              alt="Dokumentasi proyek pekerjaan bekisting dan steger"
              className="h-full w-full"
              testid="gallery-item-3"
            />
          </Reveal>
        </div>
      </div>

      <div
        className="-mx-5 mt-12 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-4 lg:hidden"
        data-testid="gallery-mobile-carousel"
      >
        {[
          { src: IMAGES.campus, alt: "Dokumentasi proyek gedung dengan steger", id: "gallery-mobile-1" },
          { src: IMAGES.crane, alt: "Dokumentasi proyek struktur dengan crane", id: "gallery-mobile-2" },
          { src: IMAGES.crew, alt: "Dokumentasi pekerjaan bekisting", id: "gallery-mobile-3" },
          { src: IMAGES.night, alt: "Dokumentasi proyek malam hari", id: "gallery-mobile-4" },
        ].map((img) => (
          <div key={img.id} className="w-[82vw] shrink-0 snap-center">
            <Frame src={img.src} alt={img.alt} className="aspect-[4/5] sm:aspect-[4/3]" testid={img.id} />
          </div>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p className="font-tech mt-10 text-center text-[10px] uppercase tracking-[0.3em] text-white/35">
          Real Project Documentation — CV Mitra Bangun Utama
        </p>
      </Reveal>
    </div>
  </section>
);

export default Gallery;
